import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Auth.css';
import './AuthArtDirection.css';
import transparentLogo from '../assets/branding/abogados-quiroz-transparent.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login, error } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const result = await login(email, password, rememberMe);
    setIsLoading(false);
    if (result.success) window.location.href = '/';
  };

  return <div className="auth-container"><div className="auth-shell">
    <aside className="auth-brand-panel">
      <div className="login-brand-logo-wrap"><img className="login-brand-logo" src={transparentLogo} alt="Abogados Quiroz" /></div>
      <div>
        <p className="auth-brand-name">ABOGADOS QUIROZ</p>
        <h1>Legal Operations Platform</h1>
        <p className="auth-capabilities">Clientes <i>•</i> Expedientes <i>•</i> Documentos <i>•</i> Automatización <i>•</i> Inteligencia Artificial</p>
        <blockquote>“Tu historia es nuestro motor.<br />Tus objetivos son nuestro compromiso.”</blockquote>
      </div>
    </aside>
    <div className="auth-card">
      <div className="auth-header"><h1>Bienvenido</h1><p>Ingrese con sus credenciales institucionales.</p></div>
      <form onSubmit={handleSubmit} className="auth-form">
        {error && <div className="auth-error"><span>⚠️</span> {error}</div>}
        <div className="form-group"><label>Email</label><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="tu@quirozlawfirm.com" autoComplete="email" required /></div>
        <div className="form-group"><label>Contraseña</label><div className="password-input-wrap"><input type={showPassword ? 'text' : 'password'} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="••••••••" autoComplete="current-password" required /><button type="button" className="password-visibility" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}>{showPassword ? '🙈 Ocultar' : '👁️ Mostrar'}</button></div></div>
        <label className="remember-session"><input type="checkbox" checked={rememberMe} onChange={(event) => setRememberMe(event.target.checked)} /><span>Mantener mi sesión iniciada en este equipo</span></label>
        <button type="submit" className="btn-auth" disabled={isLoading}>{isLoading ? 'Ingresando…' : 'Acceder al Workspace'}</button>
        <p className="auth-link"><a href="/forgot-password">¿Olvidaste tu contraseña?</a></p>
        <p className="auth-authorized">Acceso exclusivo para personal autorizado.</p>
      </form>
    </div>
  </div></div>;
};

export default Login;
